// extracted by mini-css-extract-plugin
export var cardHeader = "_v5-0";
export var reorderHandle = "_v5-3";
export var titleArea = "_v5-1";
export var titleAreaWithHandle = "_v5-2";